<template>
  <div class="serviceMain">
    <div class="searchBar">
      <div class="tittle"> 我的登记 </div>
      <div class="rightForm">
        <el-input
          v-model="form.subject"
          placeholder="请输入作品名称"
        ></el-input>
        <el-date-picker
          v-model="form.date"
           value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
       <el-button @click="fetchData">查询</el-button>
        <router-link :to="{path:'/Register/InputForm'}">
            <el-button type="primary">新增登记</el-button>
        </router-link>
      </div>
    </div>

    <el-table
      :data="tableData"
      :cell-class-name="tabelCellClass"
      style="width: 100%"
      @row-click="onTabelRowClick"
    >
      <el-table-column
        prop="subject"
        label="登记名称"
         show-overflow-tooltip
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="createTimeText"
        label="创建时间"
        sortable
        width="150"
      >
        <!-- eslint-disable-next-line -->
        <template slot="header" slot-scope="scope">
          <div class="createTimeHeader">
            <span>创建时间</span>
            <a-tooltip>
              <template slot="title">
                prompt text
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="stausCell"
            :class="{'stausCell1':scope.row.status=='10','stausCell2':scope.row.status=='11','stausCell3':scope.row.status=='21'}"
          >
            {{scope.row.statusText}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="certificate"
        label="证书"
        width="180"
      >
        <template slot-scope="scope">
          <div class="signList">
                 <span
              class="greenSpan"
            >
              存
           
            </span>
               <span
              class="graySpan"
            >
              公
           
            </span>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="100"
        fixed="right"
      >
        <!-- eslint-disable-next-line -->
        <template slot-scope="scope">
          <!-- {{scope.row.status}} -->
       
               <a-dropdown
            :trigger="['click']"
            placement="bottomLeft"
            overlayClassName="moveLeft"
          >
            <a @click.stop="e => e.preventDefault()">
              <a-icon type="more" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                 <router-link :to="{path:'/Register/InputForm'}"> 重新登记 </router-link>  
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <a-icon type="right" class="ml12 gray" />
       
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
     :total="pagination.total"
      :current-page.sync="pagination.page"
      :page-size.sync="pagination.pageSize"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>

  </div>
</template>

<script>
import {queryRegisterOrderList} from '@/api/EvidenceService'
export default {
  name: 'MyRegister',
  data () {
    return {
      form: {
         subject: null,
        date: null
      },
      pagination: {
         total:0,
        page: 1,
        pageSize: 10
      },
      tableData:[],
      // tableData2: [{
      //   name: '《鄂菜大全》',
      //   orderNo: '109000990099998',
      //   date: '2019-12-23 14:07',
      //   status: 1, // 1、待付款  2、处理中  3、已完成
      //   statusDesc: "处理中",
      //   certificate: [
      //     {
      //       status: 1, // 1、处理中  2、完成
      //       value: 1, // 1、存   2、取   3、公
      //       label: '存'
      //     },
      //   ],

      // }, {
      //   name: '《鄂菜大全》',
      //   orderNo: '109000990099998',
      //   date: '2019-12-23 14:07',
      //   status: 1, // 1、失败  2、审核中  3、已完成
      //   statusDesc: "失败",
      //   certificate: [
      //     {
      //       status: 2, // 1、处理中  2、完成
      //       value: 1, // 1、存   2、取   3、公
      //       label: '存'
      //     },
      //     {
      //       status: 2, // 1、处理中  2、完成
      //       value: 2, // 1、存   2、取   3、公
      //       label: '取',
      //       num: 1
      //     },
      //     {
      //       status: 2, // 1、处理中  2、完成
      //       value: 3, // 1、存   2、取   3、公
      //       label: '公'
      //     },
      //   ],

      // }]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    onTabelRowClick(row){
      this.$router.push({
        path: "/Register/Detail",
            query: {orderNo:row.orderNo}
      });
    },
    tabelCellClass ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'certificate') {
        return 'certificateCell'
      }
    },
    getStatus(code){
        switch(code){
          case '10':return '待付款';
          case '11':return '待处理';
          case '21':return '已完成';
          case '31':return '失败';
        }
    },
    fetchData (param) {
        queryRegisterOrderList(this.pagination.page,this.pagination.pageSize,this.form).then(({data})=>{
            for (let i = 0; i < data.list.length; i++) {
            const element = data.list[i];
             element.num=element.items.length;
             element.statusText=this.getStatus(element.status);
              element.createTimeText= this.dayjs(element.createTime*1000).format('YYYY-MM-DD HH:mm:ss ');
      // this.orderInfo.updateTimeText= this.dayjs(this.orderInfo.updateTime*1000).format('YYYY-MM-DD HH:mm:ss ');
          }
          this.tableData=data.list;
          this.pagination.total=data.total*1;
        });
    },
    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },
  }
}
</script>

<style lang='scss' scoped>
@import '../../../assets/css/mine.scss';
</style>
